import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as selectMissingWordServices from '@iso/services/listening/selectMissingWord';

//#region CRUD
export function* getSelectMissingWord() {
	yield takeLatest(actions.GET_SELECT_MISSING_WORD, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(selectMissingWordServices.getSelectMissingWord, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_SELECT_MISSING_WORD_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getSelectMissingWordDetail() {
	yield takeLatest(actions.GET_SELECT_MISSING_WORD_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(selectMissingWordServices.getSelectMissingWordDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_SELECT_MISSING_WORD_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesSelectMissingWord() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_SELECT_MISSING_WORD, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(selectMissingWordServices.createQuesSelectMissingWord, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateSelectMissingWordDetail() {
	yield takeLatest(actions.UPDATE_SELECT_MISSING_WORD_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(selectMissingWordServices.updateSelectMissingWordDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteSelectMissingWord() {
	yield takeLatest(actions.DELETE_SELECT_MISSING_WORD, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(selectMissingWordServices.deleteSelectMissingWord, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getSelectMissingWord),
		fork(getSelectMissingWordDetail),
		fork(createQuesSelectMissingWord),
		fork(updateSelectMissingWordDetail),
		fork(deleteSelectMissingWord),
	]);
}
